import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const EMPTY = { facebook: "", linkedin: "", videos: [], driveLinks: {}, fees: [], feeNote: "", feeValidity: "", campusMaps: {} };
let cache = null;
let inflight = null;

export const loadSettings = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) inflight = api.get("/settings").then((r) => { cache = r.data; return cache; }).finally(() => { inflight = null; });
  return inflight;
};

export const useSettings = () => {
  const [s, setS] = useState(cache || EMPTY);
  useEffect(() => {
    let on = true;
    loadSettings().then((d) => on && setS(d)).catch(() => {});
    return () => { on = false; };
  }, []);
  return s;
};

export const youtubeId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|live\/))([\w-]{11})/);
  return m ? m[1] : null;
};
